import { Box, Grid } from '@mui/material';
import { useEffect, useRef } from 'react';
import { RouterTabs, type RouterTabsProps } from '~/components/RouterTabs';
import { useLocation } from '~/hooks/location';

export interface FullscreenPanelContainerProps {
  children: React.ReactNode;
}

export const FullscreenPanelContainer = ({ children }: FullscreenPanelContainerProps) => {
  const containerRef = useRef<HTMLDivElement>();

  // fix column-reverse scrolling to bottom by default
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    container.scrollTop = -(container.scrollHeight - container.clientHeight);
  });

  return (
    <Grid
      container
      direction={{ xs: 'column-reverse', sm: 'row' }}
      ref={(x) => (containerRef.current = x ? x : undefined)}
      spacing={2}
      sx={{
        height: { xs: 'auto', sm: '100%' },
        flexWrap: { xs: 'nowrap', sm: 'wrap' },
        overflow: { xs: 'auto', sm: 'hidden' },
      }}
    >
      {children}
    </Grid>
  );
};

export interface FullscreenPanelLeftProps {
  children: React.ReactNode;
  tabs: RouterTabsProps['tabs'];
}

export const FullscreenPanelLeft = ({ children, tabs }: FullscreenPanelLeftProps) => {
  const location = useLocation();

  return (
    <Grid
      item
      xs={12}
      sm={4}
      zeroMinWidth
      sx={(theme) => ({
        borderRight: { xs: 'none', sm: `1px solid ${theme.palette.borders.light}` },
      })}
    >
      <nav>
        <RouterTabs
          allowScrollButtonsMobile
          scrollButtons
          sx={{ padding: 0, paddingTop: 1 }}
          tabs={tabs}
          variant="scrollable"
          TabProps={{ replace: true, state: location.state }}
        />
      </nav>
      <Box
        sx={{
          background: (theme) => theme.palette.common.white,
          display: 'flex',
          flexDirection: 'column',
          height: { xs: 'auto', sm: 'calc(100vh - 112px)' },
          overflow: 'auto',
          paddingBottom: { xs: '57px', sm: '0' },
        }}
      >
        <Box sx={{ padding: 2 }}>{children}</Box>
      </Box>
    </Grid>
  );
};

export interface FullscreenPanelRightProps {
  children: React.ReactNode;
}

export const FullscreenPanelRight = ({ children }: FullscreenPanelRightProps) => (
  <Grid item xs={12} sm zeroMinWidth>
    <Box sx={{ padding: 2 }}>{children}</Box>
  </Grid>
);
